import { processGenderDistributionData } from "../utils/dataProcessors";

import { useDemographicsData } from "./useDemographicsData";

export const useDemographicsGenderDistributionData = () => {
    return useDemographicsData({
        select: (data) => processGenderDistributionData(data?.GenderRatios),
    });
};
